import { create, node } from '@dojo/framework/core/vdom';

const factory = create({ node });

/**
 * cssProperty middleware
 *
 * `get` queries a property from a vdom node and returns the value
 * `set` changes a property
 *
 * Using a key of ':root' instead of a vdom node's key will use the
 * `documentElement` (global properties) instead.
 */
export const cssProperty = factory(({ middleware: { node } }) => {
	return {
		get(key: string | number, prop: string): string | undefined {
			const domNode = key === ':root' ? document.documentElement : node.get(key);
			if (!domNode) {
				return undefined;
			}
			return getComputedStyle(domNode).getPropertyValue(prop);
		},
		set(key: string | number, prop: string, value: string): boolean {
			const domNode = key === ':root' ? document.documentElement : node.get(key);
			if (!domNode) {
				return false;
			}
			domNode.style.setProperty(prop, value);
			return true;
		}
	};
});
